module.exports = __webpack_public_path__ + "static/complex_scroll_5-ca0390073bfc2c01366cd6e7f3909b07.png";